import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { Region, ListResponse } from '@/types';
import { Pagination } from '@/components';
import { EditFlat, ExternalLinkOutlined, TrashFlat } from '@/assets/icons';
import theme from '@/theme';

import { DeleteRegion, UpdateRegion } from '../components';

export interface RegionListProps {
  list?: ListResponse<Region>;
  page: number;
  onChangePage(page: number): void;
}

const RegionsTable: React.FC<RegionListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentRegion, setCurrentRegion] = useState<Region | null>(null);

  function openUpdateModal(region: Region) {
    setCurrentRegion(region);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(region: Region) {
    setCurrentRegion(region);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Наименование</TableCell>
                <TableCell>Районы</TableCell>
                <TableCell>Улицы</TableCell>

                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((region) => {
                const { name, city, id } = region;

                return (
                  <TableRow key={id}>
                    <TableCell>{name}</TableCell>

                    <TableCell>
                      <Tooltip title="Районы">
                        <IconButton component={RouterLink} to={`/dictionaries/regions/${id}/areas`} aria-label="Районы">
                          <ExternalLinkOutlined sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>

                    <TableCell>
                      {city && (
                        <Tooltip title="Улицы">
                          <IconButton
                            component={RouterLink}
                            to={`/dictionaries/regions/${id}/streets`}
                            aria-label="Улицы"
                          >
                            <ExternalLinkOutlined sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(region)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(region)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateRegion region={currentRegion!} open={updateModalOpened} onClose={() => setOpenedUpdateModal(false)} />
      <DeleteRegion region={currentRegion!} open={deleteModalOpened} onClose={() => setOpenedDeleteModal(false)} />
    </>
  );
};

export default RegionsTable;
